import {RecipientFetcher} from '../../hooks/recipientFetcher';
import { Stack } from 'react-bootstrap';
import avatar from '../../avatar/avatar.svg';
import {ChatContext} from '../../contexts/ChatContext';
import {useContext} from 'react';
import moment from 'moment';
import {unreadNotificationsFunc} from '../../utils/unreadNotifications';
import LastMessageFetch from '../../hooks/lastMessageFetch';
import Media from 'react-media';


const UserChat = ({chat, user}) => {

	const {recipientUser} = RecipientFetcher(chat, user)
	const {onlineUsers, notifications, markThisUserNotificationsAsRead} = useContext(ChatContext);

	const isOnline = onlineUsers?.some((user) => user?.userId === recipientUser?._id)
	const unreadNotifications = unreadNotificationsFunc(notifications);
	const thisUserNotifications = unreadNotifications?.filter(
		thisNotif => thisNotif.senderId === recipientUser?._id
	)
	const { latestMessage } = LastMessageFetch(chat);

	const truncateText = (text) => {
		let shortText = text.substring(0, 10);

		if(text.length > 10){
			shortText = shortText + '...'
		}

		return shortText;
	}


	return(
		<Stack 
			direction="horizontal" 
			// gap={3} 
			className="user-card align-items-center p-2 mt-2 justify-content-between"
			role="button"
			onClick = {() => {
				if(thisUserNotifications?.length !== 0){
					markThisUserNotificationsAsRead(
						thisUserNotifications, notifications)
				}
			}}
		>
			<Media query="(min-width: 600px)">
				{matches => {
					return matches ? 
					<>
						<div className="d-flex"> 
							<div className="me-2"> 
								<img src={avatar} height="35px" alt="ava"/>
							</div>
							<div className="me-2">
								<div className="name">{recipientUser?.name}</div>
								<div className="text">
									{
										latestMessage?.text && (
											<span>{truncateText(latestMessage?.text)}</span>
										)
									}
								</div>
							</div>
						</div>
						<div className="d-flex flex-column align-items-end">
							<div className="date">
								{moment(latestMessage?.createdAt).calendar()}
							</div>
							{unreadNotifications.length ? 
								<div className={thisUserNotifications?.length > 0 ? "this-user-notifications": ""}>
									{thisUserNotifications?.length > 0 ? thisUserNotifications?.length : ""}
								</div>
								: 
								<div className="zero-notifications"></div>
							}
							
							<span className={isOnline ? "user-online" : ""}></span>
						</div>
					</>
					:
					<>
					<div className="d-flex"> 
						<div className="me-2" > 
							<div className="name">{recipientUser?.name}</div>
							<span className={isOnline ? "user-online-small-devices" : ""}></span>
						</div>
						<div className="d-flex flex-column align-items-end">
							{unreadNotifications.length ? 
								<div className={thisUserNotifications?.length > 0 ? "this-user-notifications": ""}>
									{thisUserNotifications?.length > 0 ? thisUserNotifications?.length : ""}
								</div>
								: 
								<div className="zero-notifications"></div>
							}
							
						</div>
					</div>
					</>
				}}
				
			</Media>
		</Stack>
	)
}

export default UserChat;